var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMovie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.694,
    x2: 495.895,
    xlinkHref: "#lg1",
    y1: 94.444,
    y2: 144.645
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    stopColor: "#ed725d",
    stopOpacity: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8514,
    stopColor: "#fa704b",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.795,
    x2: 518.459,
    xlinkHref: "#lg2",
    y1: 93.124,
    y2: 50.111
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.335,
    x2: 507.49,
    xlinkHref: "#lg1",
    y1: 148.07,
    y2: 189.226
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.21,
    x2: 525.988,
    xlinkHref: "#lg2",
    y1: 146.988,
    y2: 111.726
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.184,
    x2: 273.339,
    xlinkHref: "#lg1",
    y1: 78.748,
    y2: 119.903
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.059,
    x2: 291.838,
    xlinkHref: "#lg2",
    y1: 77.666,
    y2: 42.404
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.886,
    x2: 437.463,
    xlinkHref: "#lg1",
    y1: 54.253,
    y2: 127.83
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.387,
    x2: 528.203,
    xlinkHref: "#lg2",
    y1: 69.303,
    y2: 13.737
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.686,
    x2: 274.262,
    xlinkHref: "#lg1",
    y1: 133.747,
    y2: 207.323
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.186,
    x2: 365.003,
    xlinkHref: "#lg2",
    y1: 148.796,
    y2: 93.23
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.963,
    x2: 339.847,
    xlinkHref: "#lg1",
    y1: 59.472,
    y2: 125.355
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.062,
    x2: 402.865,
    xlinkHref: "#lg2",
    y1: 77.245,
    y2: 29.835
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.594,
    x2: 328.171,
    xlinkHref: "#lg1",
    y1: 149.205,
    y2: 222.782
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.095,
    x2: 418.911,
    xlinkHref: "#lg2",
    y1: 164.255,
    y2: 108.689
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.806,
    x2: 458.791,
    xlinkHref: "#lg1",
    y1: 128.39,
    y2: 210.375
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.847,
    x2: 529.737,
    xlinkHref: "#lg2",
    y1: 147.803,
    y2: 88.295
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -918.956 -780.901)",
    gradientUnits: "userSpaceOnUse",
    x1: 235.99,
    x2: 267.526,
    xlinkHref: "#lg1",
    y1: 1534.112,
    y2: 1609.412
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.001,
    x2: 209.964,
    xlinkHref: "#lg2",
    y1: 292.433,
    y2: 139.034
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.047,
    x2: 466.626,
    xlinkHref: "#lg3",
    y1: 218.653,
    y2: 466.454
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.42,
    x2: 143.086,
    xlinkHref: "#lg4",
    y1: 465.645,
    y2: 264.883
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.566,
    x2: 337.566,
    xlinkHref: "#lg4",
    y1: 442.523,
    y2: 490.813
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.423,
    x2: 448.873,
    xlinkHref: "#lg5",
    y1: 235.924,
    y2: 450.62
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.035,
    x2: 225.48,
    xlinkHref: "#lg6",
    y1: 400.903,
    y2: 302.642
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.566,
    x2: 337.566,
    xlinkHref: "#lg6",
    y1: 456.661,
    y2: 485.782
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.904,
    x2: 425.694,
    xlinkHref: "#lg3",
    y1: 263.65,
    y2: 436.966
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 1 -1849.325 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1974.94,
    x2: -1932.415,
    y1: 75.207,
    y2: 117.732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.327,
    x2: 137.327,
    xlinkHref: "#lg1",
    y1: 480.696,
    y2: 493.52
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.016,
    x2: 262.311,
    xlinkHref: "#lg5",
    y1: 302.238,
    y2: 337.033
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.249,
    x2: 98.794,
    xlinkHref: "#lg6",
    y1: 348.332,
    y2: 86.906
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.327,
    x2: 137.327,
    xlinkHref: "#lg3",
    y1: 126.959,
    y2: 151.019
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.327,
    x2: 137.327,
    xlinkHref: "#lg3",
    y1: 143.16,
    y2: 176.572
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.348,
    x2: 260.725,
    xlinkHref: "#lg3",
    y1: 407.055,
    y2: 303.139
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 460.197,
    cy: 108.946,
    fill: "url(#SVGID_1_)",
    r: 38.761
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.535 74.273c2.614 5.217 4.088 11.106 4.088 17.339 0 21.407-17.354 38.761-38.761 38.761-6.233 0-12.121-1.474-17.339-4.088 6.364 12.701 19.499 21.422 34.673 21.422 21.407 0 38.761-17.354 38.761-38.761 0-15.174-8.72-28.309-21.422-34.673z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 478.224,
    cy: 159.96,
    fill: "url(#SVGID_3_)",
    r: 31.776
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.438 131.535c2.143 4.277 3.351 9.104 3.351 14.214 0 17.549-14.227 31.776-31.776 31.776-5.11 0-9.937-1.208-14.214-3.351 5.217 10.413 15.985 17.562 28.425 17.562 17.549 0 31.776-14.227 31.776-31.776 0-12.44-7.149-23.208-17.562-28.425z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 244.073,
    cy: 90.637,
    fill: "url(#SVGID_5_)",
    r: 31.776
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.287 62.213c2.143 4.277 3.351 9.104 3.351 14.214 0 17.549-14.227 31.776-31.776 31.776-5.11 0-9.937-1.208-14.214-3.351 5.217 10.413 15.985 17.562 28.425 17.562 17.549 0 31.776-14.227 31.776-31.776 0-12.44-7.149-23.208-17.562-28.425z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 385.141,
    cy: 75.509,
    fill: "url(#SVGID_7_)",
    r: 56.809
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.554 24.691c3.832 7.647 5.991 16.277 5.991 25.412 0 31.375-25.434 56.809-56.809 56.809-9.135 0-17.765-2.16-25.412-5.991 9.327 18.615 28.578 31.396 50.818 31.396 31.375 0 56.809-25.434 56.809-56.809-.001-22.238-12.782-41.489-31.397-50.817z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 221.941,
    cy: 155.002,
    fill: "url(#SVGID_9_)",
    r: 56.809
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.353 104.184c3.832 7.647 5.991 16.277 5.991 25.412 0 31.375-25.434 56.809-56.809 56.809-9.135 0-17.765-2.16-25.412-5.991 9.327 18.615 28.578 31.396 50.818 31.396 31.375 0 56.809-25.434 56.809-56.809 0-22.238-12.781-41.489-31.397-50.817z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 292.996,
    cy: 78.504,
    fill: "url(#SVGID_11_)",
    r: 50.869
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.751 33c3.431 6.847 5.365 14.575 5.365 22.755 0 28.094-22.775 50.869-50.869 50.869-8.18 0-15.908-1.934-22.755-5.365 8.352 16.669 25.59 28.114 45.504 28.114 28.094 0 50.869-22.775 50.869-50.869 0-19.913-11.445-37.152-28.114-45.504z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 275.849,
    cy: 170.461,
    fill: "url(#SVGID_13_)",
    r: 56.809
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.261 119.643c3.832 7.647 5.991 16.277 5.991 25.412 0 31.375-25.434 56.809-56.809 56.809-9.135 0-17.765-2.16-25.412-5.991 9.327 18.615 28.578 31.396 50.818 31.396 31.375 0 56.809-25.434 56.809-56.809 0-22.238-12.781-41.49-31.397-50.817z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400.49,
    cy: 152.074,
    fill: "url(#SVGID_15_)",
    r: 63.301
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.807 95.449c4.27 8.521 6.676 18.137 6.676 28.316 0 34.96-28.341 63.301-63.301 63.301-10.179 0-19.796-2.406-28.316-6.676 10.393 20.743 31.844 34.985 56.625 34.985 34.96 0 63.301-28.341 63.301-63.301 0-24.781-14.242-46.232-34.985-56.625z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 340.477,
    cy: 140.198,
    fill: "url(#SVGID_17_)",
    r: 49.539
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.941 211.81c4.598 0 9.064-.56 13.346-1.592 10.31 10.518 24.671 17.051 40.563 17.051 19.239 0 36.228-9.574 46.5-24.209l-50.501-50.501c-3.625-6.294-10.405-10.542-18.19-10.542h-3.572c-.008-.002-.016-.004-.023-.006-1.027-3.758-13.295-15.875-18.389-15.875h-58.663c-5.002 8.46-7.878 18.325-7.878 28.866-.002 31.374 25.432 56.808 56.807 56.808z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.446 491.3h-72.666l-21.365-6-25.125 6h-72.604c-11.784 0-21.853-8.491-23.841-20.106l-47.008-274.52c-1.41-8.232 4.931-15.751 13.283-15.751h306.892c8.352 0 14.693 7.519 13.283 15.751l-47.008 274.52c-1.988 11.615-12.057 20.106-23.841 20.106z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.686 491.3h72.33l22.312-7 24.603 7h72.515c11.784 0 21.853-8.491 23.841-20.106l19.473-113.723-176.547-176.548h-116.093c-8.352 0-14.693 7.519-13.283 15.751l47.008 274.52c1.988 11.615 12.057 20.106 23.841 20.106z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.776 400.715 12.069 70.479c1.989 11.615 12.058 20.106 23.841 20.106h72.964l22.952-8 23.445 8h72.399c11.784 0 21.853-8.491 23.841-20.106l12.069-70.479z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.388 491.3h-37.85l-23.887-8-23.534 8h-38.373c-7.598 0-14.09-8.491-15.373-20.106l-32.049-290.271h68.059l39.808 10 42.776-10h67.844l-32.049 290.271c-1.282 11.615-7.774 20.106-15.372 20.106z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.761 471.194 17.472-158.251-132.02-132.02h-71.89l32.049 290.271c1.282 11.615 7.775 20.106 15.373 20.106h38.369l23.649-11 23.544 11h38.083c7.596 0 14.088-8.491 15.371-20.106z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.761 471.194 7.782-70.479h-169.953l7.782 70.479c1.282 11.615 7.775 20.106 15.373 20.106h38.231l23.938-6 23.384 6h38.09c7.598 0 14.09-8.491 15.373-20.106z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.969 491.3h-46.806c-2.876 0-5.334-8.491-5.819-20.106l-12.132-290.271h82.708l-12.132 290.271c-.485 11.615-2.943 20.106-5.819 20.106z",
    fill: "url(#SVGID_25_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m366.788 471.194 2.946-70.479h-64.336l2.946 70.479c.485 11.615 2.943 20.106 5.819 20.106l22.677-9 24.129 9c2.876 0 5.334-8.491 5.819-20.106z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m38.251 67.502 35.657-28.793c6.416-5.181 14.67-6.947 22.644-4.838 7.974 2.106 14.279 7.716 17.3 15.391l36.844 92.702c.795 2-.198 4.264-2.207 5.035-6.903 2.647-14.652-.75-17.383-7.621l-33.306-83.799c-.987-2.508-3.048-4.342-5.654-5.03-2.605-.688-5.304-.113-7.4 1.581l-35.657 28.794c-3.706 2.993-9.136 2.414-12.13-1.292-2.993-3.706-2.414-9.137 1.292-12.13z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m203.684 491.3h-132.715c-6.393 0-11.576-5.183-11.576-11.576v-10.338h155.867v10.338c0 6.393-5.182 11.576-11.576 11.576z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.942 479.429h-117.231c-16.507 0-30.315-12.535-31.906-28.965l-36.192-292.988h253.427l-36.191 292.988c-1.592 16.43-15.4 28.965-31.907 28.965z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.428 184.128 220.128 220.128 30.484-246.78h-253.427z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.728 157.476h-210.803v-20.286c0-6.105 4.949-11.054 11.054-11.054h188.695c6.105 0 11.054 4.949 11.054 11.054z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.658 185.539h-232.663c-11.595 0-20.995-9.4-20.995-20.995v-1.533c0-11.595 9.4-20.995 20.995-20.995h232.663c11.595 0 20.995 9.4 20.995 20.995v1.533c0 11.595-9.4 20.995-20.995 20.995z",
    fill: "url(#SVGID_32_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m366.788 471.194 8.975-214.721-75.55-75.55h-4.001l12.132 290.271c.485 11.615 2.943 20.106 5.819 20.106h22.132 24.673c2.877 0 5.335-8.491 5.82-20.106z",
    fill: "url(#SVGID_33_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMovie);
export default __webpack_public_path__ + "static/media/icon-movie.74f3a2e96482c70f959271df2092e0b8.svg";
export { ForwardRef as ReactComponent };